import { Component } from "@angular/core";
import { FeatureFlagsService } from "@core/services/feature-flags.service";
import { ENABLE_ENROLLMENT_BANNER } from "@core/constants/feature-flags";

@Component({
    selector: "app-enrollment-banner",
    templateUrl: "./enrollment-banner.component.html",
    styleUrls: ["./enrollment-banner.component.scss"],
    standalone: false,
})
export class EnrollmentBannerComponent {
    constructor(private featureFlags: FeatureFlagsService) {}

    get showEnrollmentBanner(): boolean {
        return this.featureFlags.isFeatureEnabled(ENABLE_ENROLLMENT_BANNER);
    }
}
